import React, { useEffect, useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { useFormik } from "formik";
import { createColumns, confirmDelete, sortArrayNumProp } from "../../../redux/utils";
import { SortableList, CustomProperties, UnsortableList } from "../";
import { CustomGridProperties } from "../objects";
import { SettingsOverscanOutlined } from "@material-ui/icons";
import { useSnackContext } from "../../contexts/Snack";

const objectPath = require("object-path");

export const TabSelectOqt = (props) => {

  
  const { fromSelf, formik, details, section, name, caption, data, item, rootValues, order = "no_order", maxWidth = "md", variant = "outlined" } = props;

  const loadList = () => {
    return item[name] ? sortArrayNumProp(item[name], order) : item[name]
  }

  const [ state, setState ] = useState(()=>({open: false, values: {}, list: loadList(), changeOrder: 0}));
  const [ fields, setFields ] = useState([]);
  const [ valid, setValid ] = useState(false);
  const [ schema, setSchema ] = useState();
  const [ selectList, setSelectList ] = useState();
  const { openAxiosError, openSuccess } = useSnackContext();
    
  useEffect(()=>{
    setState(state => ({...state, list: loadList()}));
  }, [item[name]])

  useEffect(()=>{
    if(state.changeOrder>0){
      state.list.forEach(item =>
        data.editItem(item.id, item, section)
      )
    }
  }, [state.changeOrder])

  const newItemValues = () => {
    return {
      ...fields.reduce((p, c) => ({...p, [c.name]: c.defaultValue && eval(c.defaultValue)({item, data, name, caption, fields})}), { id: 0 })
    } 
  };

  useEffect(() => {
    data.getSchema(section).then(response => {
      setSchema(response);
    })
  }, [data.getSchema, section])

  const simpleSelectOqt = useMemo(()=> schema && schema.fields.find(field => field.type === "SimpleSelectOqt"), [schema])

  useEffect(() => {
    if(simpleSelectOqt){

      const regexp = /{{((\w+)(.\w+|\[\d+\])+?)}}/g
      const matches = simpleSelectOqt.options.match(regexp);
      const optionsExp = matches ? matches.reduce( (prev, curr) => prev.replace(curr,  objectPath.get({...item, rootValues}, `${curr.replace("{{", "").replace("}}", "")}`)), simpleSelectOqt.options) : simpleSelectOqt.options;
      
      data.getTable(decodeURI(optionsExp)).then(selectList =>{ 
        const newSelectList = fromSelf ? selectList.value.filter(selectItem => selectItem.value !== item.id) : selectList.value;
        setSelectList(newSelectList);
      })
    }
  }, [simpleSelectOqt, data.getTable, item, fromSelf, rootValues])

  useEffect(() => {
    if(state.list && selectList && schema && simpleSelectOqt) {
      const newSelectList = selectList.filter(selectItem => !state.list.some(localItem => localItem[simpleSelectOqt.name] === selectItem.value));
      let isFirst = true;
      const newFields = schema.fields.map( field => {
        if(field.type === "SimpleSelectOqt" && isFirst){
          isFirst = false;
          return {...field, options: undefined, optionsList: newSelectList};
        }else{
          return field;
        } 
      });
      setFields(newFields);
    }
  }, [state.list, selectList, schema, simpleSelectOqt])

  const fmk = useFormik({
    initialValues: {},
    validationSchema: props.validationSchema && props.validationSchema.innerType,
    onSubmit: values => {
        fmk.setSubmitting(true);
        const parentField = fields.find(x => x.type === "parentId");
        const nextOrder = state.list.reduce((prev, curr) => curr[order] > prev ? curr[order] : prev, 0) + 1;
        const newItem = {...values, [parentField.name]: item.id, [order]: nextOrder}
        data.addItem(newItem, section)
          .then(response=>{
            setState((prev) => {
              const list = [...prev.list ? prev.list : [], response];
              return {...prev, list, open: false};
            });
            openSuccess("El elemento se agregó correctamente.");
          })
          .catch(error => {
            openAxiosError(error);
          })
          .finally(()=>{
            fmk.setSubmitting(false);
          })
    }
  })


  const handleSubmit = () => {
    fmk.validateForm()
    .then( () => {
      fmk.submitForm();
    })
    .catch( error => {
      console.log(error)
    });
  }

  const handleChangeValues = (values) => {
    fmk.setValues(values);
  }

  const handleClose = () => {
    setState({...state, open: false});
  }

  const handleOpen = () => {
    setState({...state, open: true});
  }

  const handleDeleteClick = ({row}) => {
    const primaryText = columns
    .filter(x => x.field !== "acciones")
    .map(c => c.renderCell ? c.renderCell({row, extraData: data}) : ( item ? item[c.field] : "" ) )
    .filter(x => x !== ""); 
    confirmDelete({
      html: "Está seguro de eliminar este elemento?"
    }).then(()=>{

      data.removeItem(row, section)
        .then(response=>{
          //console.log(response);
          openSuccess('El elemento se eliminó correctamente.');
          setState((prev) => {
            const list = prev.list.filter(x => x.id !== response.id);
            return {...prev, list, changeOrder: order === "no_order" ? prev.changeOrder : prev.changeOrder + 1};
          });
          openSuccess("El elemento se eliminó correctamente.");
        })
        .catch(error => {
          openAxiosError(error)
        })
    })

  }

  const handleAddItem = () => {
    setState({...state, open: true, values: newItemValues()});
  }

  const handleReorderList = (list) => {
    setState((prev) => {
      //formik.setFieldValue(name,);
      const newList =  list.map((x, index) => ({...x, [order]: index}));
      return {...prev, list: newList, changeOrder: prev.changeOrder + 1};
    })
  }

  const columns = createColumns({fields, disabled: details})({onDelete: handleDeleteClick});

  return (
    <div style={{margin: "8px"}}>

      {variant == "outlined" && caption}
      {
        order === "no_order"
          ? <UnsortableList   
              data={data}
              details={details}
              rows={state.list} 
              columns={columns}
              addItem={<Button fullWidth variant="text" onClick={handleAddItem}>Agregar</Button>}
            />
          : <SortableList   
              data={data}
              details={details}
              onReorderList={handleReorderList} 
              rows={state.list} 
              columns={columns}
              addItem={<Button fullWidth variant="text" onClick={handleAddItem}>Agregar</Button>}
            />
        }
      
      <Dialog fullWidth onClose={handleClose} open={state.open} keepMounted={false} maxWidth={maxWidth}>
        <DialogTitle>{`Agregar item en ${caption.toLowerCase()}`} </DialogTitle>
        <DialogContent>
          <CustomGridProperties submitting={state.submitting} onValidChange={setValid} validationSchema={props.validationSchema && props.validationSchema.innerType} {...{data, name, item, fields, rootValues}} initialValues={state.values} onChange={handleChangeValues} />
          <DialogContentText>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button disabled={!valid || fmk.isSubmitting} onClick={handleSubmit} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

}